import React, { useRef, useState, useEffect, useContext } from "react";
import Input from "../../UI/Input";
import Button from "../../UI/Button";
import AppContext from "../../../store/app-context";

import styles from "./ItemForm.module.css";

const ItemForm = (props) => {
  const appCtx = useContext(AppContext);

  let label_qty = 'Quantity';
  let label_update = 'Update Qty';
  let label_errorInvalidQunatity = 'Invalid Qty';

  if(appCtx && appCtx.bioradResources){
    label_qty = appCtx.bioradResources.Quantity ? appCtx.bioradResources.Quantity : 'Quantity';
    label_update = appCtx.bioradResources.Update_Quote ? appCtx.bioradResources.Update_Quote : 'Update Qty';
    label_errorInvalidQunatity = appCtx.bioradResources.Invalid_Qty ? appCtx.bioradResources.Invalid_Qty : 'Invalid Qty';
  }

  const [showUpdateButton, setShowUpdateButton] = useState(false);
  const [isValidQuantity, setIsValidQuantity] = useState(true);
  const [quantity, setQuantity] = useState(props.value);

  const quantityInputRef = useRef();

  useEffect(() => {
    setQuantity(props.value);
    setShowUpdateButton(false);
  },[props.value]);

  const quantityFormSubimtHandler = (event) => {
    event.preventDefault();

    const enteredQuantityStr = quantityInputRef.current.value;

    const enteredQuantityNumber = +enteredQuantityStr;

    if (enteredQuantityStr.trim().length === 0 || enteredQuantityNumber < 1 || enteredQuantityNumber > 999) {
      setIsValidQuantity(false);
      return;
    }
    setIsValidQuantity(true);
  };

  const changeHandler = (event) => {
    event.preventDefault();
    if(event.target.value && event.target.value > 999){
      event.target.value = 999;
    }
    const qty = event.target.value && event.target.value !== '0' ? event.target.value : '1';
    if (qty.trim().length === 0 || qty < 1 || qty > 999) {
      setIsValidQuantity(false);
      setShowUpdateButton(false);
      return;
    }
    setIsValidQuantity(true);
    if (props.value && qty) {
      setQuantity(qty);
      if (parseInt(props.value) !== parseInt(qty)) {
        setShowUpdateButton(true);
        props.onItemChange(event.target.id, qty, "add");
      } else {
        setShowUpdateButton(false);
        props.onItemChange(event.target.id, qty, "delete");
      }
    }
  };

  const deleteHandler = (event) => {
    event.preventDefault();
    props.deleteItemHandler(event.target.id, props.webRef)
  }

  return (
    <>
    <div className={styles.qnt__btns}>
      <Input
        ref={quantityInputRef}
        label={label_qty}
        className={styles.qntField}
        input={{
          id: props.id,
          type: "number",
          min: "1",
          max: "999",
          name: props.id,
          value: quantity,
          onChange: changeHandler,
        }}
        outline={props?.rebrand}
        rebrand={props?.rebrand}
      />
      {!isValidQuantity && <p>{label_errorInvalidQunatity}</p>}
      {showUpdateButton && <Button type="submit">{label_update}</Button>}
      <div><button className={styles.delIconField} id={`d_${props.id}`} onClick={deleteHandler} aria-label="Delete"></button></div>
      </div>
    </>
  );
};

export default ItemForm;